import { buildStepNarration } from './stepNarrationCopy.js'
import {
  DESIGN_DNA_FIGMA_FILE_NAME,
  DESIGN_DNA_FIGMA_FILE_URL,
} from './designDnaFigmaPublishDemoContent.part02.js'

export const DESIGN_DNA_FIGMA_PUBLISH_AI_LOG_STEPS = [
  {
    durationMs: 2200,
    actionName: 'Connected app',
    arguments: { app: 'Figma', project: 'Enterprise Dashboard Kit' },
    result: { ok: true, status: 'connected' },
    status: 'ok',
    stepNarration: buildStepNarration(
      'Connected to Figma — destination project Enterprise Dashboard Kit',
      'publishing M3 variables and component sets',
      0,
    ),
  },
  {
    durationMs: 3800,
    actionName: 'Opened file',
    arguments: {
      file: DESIGN_DNA_FIGMA_FILE_NAME,
      project: 'Enterprise Dashboard Kit',
    },
    result: { ok: true, fileKey: 'Y2mubgYhu7x8BPYRRPmemC' },
    status: 'ok',
    stepNarration: buildStepNarration(
      `Opened ${DESIGN_DNA_FIGMA_FILE_NAME} in Figma`,
      'importing M3 color variables from showcase',
      1,
    ),
  },
  {
    durationMs: 4600,
    actionName: 'Published variables',
    arguments: {
      collections: ['Primary', 'Secondary', 'Tertiary', 'Error', 'Neutral', 'Neutral Variant'],
      tokens: 61,
    },
    result: { ok: true },
    status: 'ok',
    stepNarration: buildStepNarration(
      '61 color variables published across 6 collections',
      'mapping MUI component sets',
      2,
    ),
  },
  {
    durationMs: 5200,
    actionName: 'Published components',
    arguments: {
      sets: ['Inputs', 'Data Display', 'Feedback', 'Surfaces', 'Navigation', 'Material Theme (M3)'],
      components: 74,
    },
    result: { ok: true },
    status: 'ok',
    stepNarration: buildStepNarration(
      '74 components published — library ready for handoff',
      'generating share link',
      3,
    ),
  },
  {
    durationMs: 2400,
    actionName: 'Shared file',
    arguments: { url: DESIGN_DNA_FIGMA_FILE_URL },
    result: { ok: true, access: 'team' },
    status: 'ok',
    stepNarration: buildStepNarration(
      'Share link ready — Enterprise Dashboard Kit',
      'publish complete',
      4,
    ),
  },
]
